import React, { useState, useEffect } from "react";
import ButtonSvg from "../../../../assets/business/images/Button-icon.svg";
// import "../../../../assets/business/css/style.css";
import { useNavigate } from "react-router-dom";
import { useProfileForm } from "../hooks/complete-profile";

const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

export default function OpeningHours() {
  const navigate = useNavigate();
  const { formData, updateForm } = useProfileForm();
  const [businessHours, setBusinessHours] = useState([]);

  useEffect(() => {
    if (formData.business_hours?.length) {
      // Load from context if available
      setBusinessHours(formData.business_hours);
    } else {
      // Default setup with proper structure
      const defaultHours = days.map((day) => ({
        day,
        is_open: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"].includes(day),
        open_time: day === "Saturday" ? "10:00" : "09:00",
        close_time: day === "Saturday" ? "16:00" : "18:00",
      }));
      setBusinessHours(defaultHours);
      // Immediately save default hours to context
      updateForm({ business_hours: defaultHours });
    }
  }, [formData.business_hours, updateForm]);

  // Generate time options for dropdowns
  const generateTimeOptions = () => {
    const times = [];
    for (let hour = 0; hour < 24; hour++) {
      for (let minute = 0; minute < 60; minute += 30) {
        const time24 = `${hour.toString().padStart(2, "0")}:${minute.toString().padStart(2, "0")}`;
        const hour12 = hour === 0 ? 12 : hour > 12 ? hour - 12 : hour;
        const ampm = hour < 12 ? "AM" : "PM";
        const time12 = `${hour12}:${minute.toString().padStart(2, "0")} ${ampm}`;
        times.push({ value: time24, label: time12 });
      }
    }
    return times;
  };

  const timeOptions = generateTimeOptions();

  const handleChange = (index, key, value) => {
    const updated = [...businessHours];
    updated[index][key] = value;
    setBusinessHours(updated);

    // Update context immediately for persistence
    updateForm({ business_hours: updated });
  };

  const handleToggle = (index) => {
    const updated = [...businessHours];
    updated[index].is_open = !updated[index].is_open;

    // If closing a day, reset times to default
    if (!updated[index].is_open) {
      updated[index].open_time = updated[index].day === "Saturday" ? "10:00" : "09:00";
      updated[index].close_time = updated[index].day === "Saturday" ? "16:00" : "18:00";
    }

    setBusinessHours(updated);

    // Update context immediately for persistence
    updateForm({ business_hours: updated });
  };

  const handleNext = () => {
    // Validate that open times are before close times
    const hasInvalidTimes = businessHours.some((dayData) => {
      if (!dayData.is_open) return false;
      return dayData.open_time >= dayData.close_time;
    });

    if (hasInvalidTimes) {
      alert("Please ensure opening times are before closing times for all open days.");
      return;
    }

    // Final save to context (though it's already been saving on each change)
    updateForm({ business_hours: businessHours });

    // Navigate to next step
    navigate("/business/complete-profile/location-details");
  };

  const handleBack = () => {
    // Save current state before navigating back
    updateForm({ business_hours: businessHours });
    navigate("/business/complete-profile/business-description");
  };

  return (
    <div className="container py-5">
      <div className="back-button">
        <button onClick={handleBack} className="d-flex align-items-center gap-2">
          <i className="fi-rr-arrow-small-left"></i> <span>Back</span>
        </button>
      </div>
      <h3 className="h3-headline text-center my-5">Business Profile Setup</h3>
      <div className="setup-box mx-auto">
        <h5 className="h4-headline text-center mb-4">Opening Hours</h5>
        <div>
          {businessHours.map((dayData, i) => (
            <div key={dayData.day} className="row align-items-center mb-3">
              <div className="col-3 subtitle-1">{dayData.day}</div>
              <div className="col-2">
                <span className={dayData.is_open ? "text-success" : "text-muted"}>{dayData.is_open ? "Open" : "Closed"}</span>
              </div>
              <div className="col-2">
                <div className="form-check form-switch">
                  <input className="form-check-input" type="checkbox" checked={dayData.is_open} onChange={() => handleToggle(i)} />
                </div>
              </div>
              {dayData.is_open && (
                <>
                  <div className="col-2">
                    <select className="form-select time-select" style={{ width: "100%" }} value={dayData.open_time} onChange={(e) => handleChange(i, "open_time", e.target.value)}>
                      {timeOptions.map((time) => (
                        <option key={time.value} value={time.value}>
                          {time.label}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-1 text-center subtitle-2">To</div>
                  <div className="col-2">
                    <select className="form-select time-select" style={{ width: "100%" }} value={dayData.close_time} onChange={(e) => handleChange(i, "close_time", e.target.value)}>
                      {timeOptions.map((time) => (
                        <option key={time.value} value={time.value}>
                          {time.label}
                        </option>
                      ))}
                    </select>
                  </div>
                </>
              )}
            </div>
          ))}
          <div className="text-center mt-4">
            <button onClick={handleNext} className="btn btn-oring">
              Continue
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
